import AbsComponent from "./AbsComponent";

export default class MyCharLayer extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
        this.loader = $('.loading');
        this.addEvents();
    }

    loadList(_account_id){
        this.loader.show();
        axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/characters.json`,
            params: {guid: _account_id} 
        })
        .then( (_res) => {
            this.render(_res.data);
            this.loader.hide();
        })
        .catch( (error, d) => console.log(error,this.name, d) )
        .then( (d) => {} );
    }

    addEvents(){
        $('#myCharacterLayer .btn-close-layer').on('click', (e)=>{
            $('#myCharacterLayer').hide();
        });
    }

    render(_d){
        $('#myCharacterLayer').show();

        let lang = $('html').attr('lang') || 'ko';

        let templ = _d.map( it=> {
            let item = $(`<div class="character-list-items" onclick="return false;">
                <div class="profileimg${it.playing?' is-online':''}">
                    ${(lang==='ko')?`
                    <img src="${this.store.getState().config.profileImgPath}/game_profile_images/bns/images?gameServerKey=${it.server_id}&charKey=${it.id}">
                    `:`
                    <img src="${this.store.getState().config.staticPath}/img/profile/${it.clazz}.png">
                    `}
                </div>
                <div class="result-items-info">
                    <div class="name">${it.name}</strong></div>
                    <span class="races">${it.class_name}</span>
                    <span class="level">Lv. ${it.level}${it.mastery_level>0?` · ${this.l10n.masteryLevel.replace('{n}', it.mastery_level)}`:``}</span>
                    <span class="server">${it.server_name}</span>
                    ${it.guild?`<span class="guild">${it.guild.guild_name}</span>`:``}
                </div>
            </div>`);
            item.on('click', (e)=>{
                $('#myCharacterLayer').hide();
                this.router.goMultiParam({ c: it.name, compare: 'false' });
            });
            return item;
        });


        $('#myCharacterLayer .my-character-list').empty().append(templ);
    }

    open(_account_id){
        if ($('#myCharacterLayer').is(':visible')) {
            $('#myCharacterLayer').hide();
        }else{
            this.loadList(_account_id);
            $('#pointAbility').hide();
        }
    }

} // end of class